/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { WigAwardsSummary } from '../wig-awards-summary.model';

@Component({
  selector: 'app-wig-awards-stats',
  templateUrl: './wig-awards-stats.component.html',
  styleUrls: ['./wig-awards-stats.component.css'],
})
export class WigAwardsStatsComponent {
  @Input() awardsSummary: WigAwardsSummary;
  @Input() claimURL: string;
  @Output() storeClosedEvent = new EventEmitter<boolean>();
  isLoading: boolean;
  isTooltipSidebarVisible = false;
  nextYear = new Date().getFullYear() + 1;

  constructor() {}

  enroll() {
    window.location.assign(this.claimURL);
  }

  hideToolTipSidebar() {
    (document.getElementsByTagName('app-root')[0] as HTMLElement).style.overflow = 'scroll';
    this.isTooltipSidebarVisible = false;
  }

  showToolTipSidebar() {
    (document.getElementsByTagName('app-root')[0] as HTMLElement).style.overflow = 'hidden';
    this.isTooltipSidebarVisible = true;
  }
}
